//@ts-ignore
import * as _ from "lodash";
import React from "react";
import { Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import AddressBar from "./components/AddressBar";
import { MapView } from "./components/MapView";
import { Planetary } from "./components/Planetary";
import {
  colorPalette,
  saveState,
  sendToast,
  setName,
  uniqueId
} from "./components/util";
import { State } from "./context/State";
import { MetaLookup } from "./models/LayerMeta";
import { initialState } from "./static/initialState";
import { MobileWarning } from "./components/MobileWarning";

export interface Layer {
  _id: string;
}

export interface GlobalState {
  layers: Layer[];
  metaLookup: MetaLookup;
  view: any;
  mapTheme: string;
  description?: string;
  showLibrary: boolean;
  showTutorial: boolean;
  showMobileWarning: boolean;
}

interface AddLayerArgs {
  layer: Layer;
  id: string;
  name?: string;
}

class App extends React.Component<{}, GlobalState> {
  private mapRef: any;
  constructor(props: any) {
    super(props);
    this.mapRef = React.createRef();
    try {
      const restoredState = JSON.parse(
        localStorage.getItem("appState") || "{}"
      );
      console.log("Restoring state", { restoredState });

      this.state = { ...initialState, ...restoredState };
    } catch (e) {
      this.state = initialState;
    }
  }

  setLayerPropById = (id: string, props: any, callback?: Function) => {
    this.setState(
      oldState => {
        const oldLookup = oldState.metaLookup;
        const oldMeta = oldLookup[id];
        const newLookup = {
          ...oldLookup,
          [id]: { ...oldMeta, ...props }
        };
        return { metaLookup: newLookup };
      },
      callback ? () => callback(this.state) : undefined
    );
  };

  getLayerProp = (layer: Layer | string, prop: string) => {
    const id = typeof layer === "string" ? layer : layer._id;
    if (typeof layer === "string") {
      return this.state.metaLookup[id][prop];
    } else {
      return this.state.metaLookup[id][prop];
    }
  };

  setLayerProp = (layer: Layer | string, prop: any, callback?: Function) => {
    if (layer === "string") {
      this.setLayerPropById(layer as string, prop, callback);
    } else {
      this.setLayerPropById((layer as Layer)._id, prop, callback);
    }
  };

  addLayer = (args: AddLayerArgs) => {
    const { layer, id, name } = args;
    // This state management needs to happen as if it's one step and work on cleanup.
    const arr: Layer[] = Array.isArray(layer) ? layer : [layer];
    const augmentedLayers = arr.map(l => {
      if (l) {
        // let _layer = turf.clone(l as any);
        let _layer = JSON.parse(JSON.stringify(l));
        _layer._id = id ? id : uniqueId();

        this.setLayerPropById(_layer._id, {
          lineColor: colorPalette(Math.random())
        });
        if (name && name.length > 0) {
          setName(_layer, name);
        }
        return _layer;
      } else {
        return l;
      }
    });

    const [good, bad] = _.partition(augmentedLayers, e => Boolean(e));
    if (bad.length > 0) {
      sendToast(
        `Could not add ${bad.length} layer${bad.length !== 1 ? "s" : ""}${
          good.length > 0
            ? `. Added ${good.length} layer${good.length !== 1 ? "s" : ""}`
            : ""
        }`
      );
    }
    if (good.length > 0) {
      this.setState(
        (state, _) => {
          return { layers: [...state.layers, ...good] };
        },
        () => {
          saveState(this.state);
        }
      );
    }
  };

  removeMetaById = (id: string) => {
    this.setState(oldState => {
      const { [id]: removedKey, ...newLookup } = oldState.metaLookup;
      return { metaLookup: newLookup };
    });
  };

  render() {
    const smallViewport = window.innerWidth < 800;

    return (
      <Route
        exact
        path={`/`}
        render={(routerProps: any) => (
          <div className="app ">
            <ToastContainer />
            <AddressBar
              view={this.state.view}
              setState={this.setState.bind(this)}
            />
            <State.Provider
              value={{
                state: this.state,
                setState: this.setState.bind(this),
                layers: this.state.layers,
                setLayers: (layers: Layer[]) => this.setState({ layers }),
                view: this.state.view,
                setView: (view: any) => this.setState({ view }),
                addLayer: this.addLayer.bind(this),
                metaLookup: this.state.metaLookup,
                getLayerProp: this.getLayerProp,
                setLayerProp: this.setLayerProp.bind(this),
                removeMetaById: this.removeMetaById,
                mapTheme: this.state.mapTheme,
                setMapTheme: (mapTheme: any, callback?: Function) =>
                  this.setState(
                    { mapTheme },
                    callback ? () => callback(this.state) : undefined
                  ),
                description: this.state.description,
                setDescription: (str: string) =>
                  this.setState({ description: str }),
                mapRef: this.mapRef,
                showLibrary: this.state.showLibrary,
                setShowLibrary: (a: boolean) =>
                  this.setState({ showLibrary: a }),
                showTutorial: this.state.showTutorial,
                setShowTutorial: () => this.setState({ showTutorial: false })
              }}
            >
              <MobileWarning />
              <MapView />
              <Planetary />
            </State.Provider>
          </div>
        )}
      />
    );
  }
}

export default App;
